import * as React from "react";

import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { useProvidedState } from "@shared-ui/provided-state-context";

import { WizardTabbed } from "components/shared/StorefrontWizard/WizardTabbed/WizardTabbed";
import { WizardHero } from "components/shared/StorefrontWizard/WizardHero/WizardHero";
import { ExtendedFTNode } from "src/typings/flexFramework/FlexComponent";
import { ClientWizardStateStore } from "src/stores/wizard/ClientWizardStateStore";
import { UitkSpacingProps, UitkSpacing } from "uitk-react-spacing";

export const StorefrontWizardRegionBEXView = (props: {
  heroImageSrc: string;
  heroImageFigureClassNames?: string;
  context: any;
  trackOnChangeTab: (tab: string) => void;
  wizardFormChildren: React.ReactElement[];
  wizardLOBs: ExtendedFTNode[];
  wizardState: ClientWizardStateStore;
  otherFormChildren: React.ReactElement[];
}) => {
  const [data] = useProvidedState();
  const isTripsHeroActive = data?.tripsHero?.isRendered ?? false;
  const className = !isTripsHeroActive ? "StorefrontWizardRegionBEX" : "StorefrontWizardRegionBEXTripsHero";

  const regionSpacing: UitkSpacingProps = { padding: { blockend: "unset" }, margin: { blockend: "unset" } };

  return (
    <UitkSpacing {...regionSpacing}>
      <div className={`${className}`} data-testid="storefront-region">
        <div id="wizardMainRegion" data-testid="main-region">
          <Viewport>
            <ViewSmall>
              <WizardTabbed
                wizardLOBs={props.wizardLOBs}
                context={props.context}
                wizardFormChildren={props.wizardFormChildren}
                trackOnChangeTab={props.trackOnChangeTab}
              />
            </ViewSmall>
            <ViewMedium>
              <WizardHero
                heroImageSrc={props.heroImageSrc}
                heroImageFigureClassNames={`bexHeroImageFigure ${props.heroImageFigureClassNames ?? ""}`}
                context={props.context}
                trackOnChangeTab={props.trackOnChangeTab}
                wizardFormChildren={props.wizardFormChildren}
                wizardLOBs={props.wizardLOBs}
                wizardState={props.wizardState}
              />
            </ViewMedium>
          </Viewport>

          {props.otherFormChildren}
        </div>
      </div>
    </UitkSpacing>
  );
};
